<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>公告</el-breadcrumb-item>
      <el-breadcrumb-item>我的公告</el-breadcrumb-item>
    </el-breadcrumb>
    <search-former @search="searchCallback" ref="former"></search-former>
    <div class="panel mt-20">
      <el-tabs
        @tab-click="handleTabClick"
        v-model="tabInex"
        class="notice-tab"
        type="border-card"
      >
        <el-tab-pane
          v-for="cate in categories"
          :name="cate.id.toString()"
          :key="cate.id"
        >
          <span slot="label"
            >{{ cate.name }}（<span
              :class="cate.not_read_count > 0 ? 'text-danger' : ''"
              >{{ cate.not_read_count }}</span
            >）</span
          >
          <el-radio-group
            size="small"
            class="mb-20 mt-20"
            v-model="filter.second_category_id"
            @change="secondCategoryChange"
            v-if="cate.children.length > 0"
          >
            <el-radio-button :label="cate.id" :key="cate.id"
              >全部</el-radio-button
            >
            <el-radio-button
              v-for="item in cate.children"
              :label="item.id"
              :key="item.id"
              >{{ item.name }}</el-radio-button
            >
          </el-radio-group>
        </el-tab-pane>
      </el-tabs>
      <div v-loading="loading">
        <el-table v-if="!isMobile()" :data="notices" style="width: 100%" border>
          <el-table-column align="left" label="标题">
            <template slot-scope="scope">
              <i
                class="os-icon os-icon-eye"
                style="color: #2f7ef5"
                v-if="scope.row.status == 1"
              ></i>
              {{ scope.row.notice.title }}
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            prop="notice.summary"
            label="摘要"
            min-width="120"
          ></el-table-column>
          <el-table-column align="center" label="发布者" width="150">
            <template slot-scope="scope">
              <span>
                {{ showPublisher(scope.row.notice) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="发布时间" width="150">
            <template slot-scope="scope">
              <span>
                {{ formatTime(scope.row.created_at) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="160">
            <template slot-scope="scope">
              <template>
                <router-link
                  :to="'/dashboard/notices/detail/' + scope.row.notice.id"
                  v-permission="Auth.userNotice"
                >
                  <el-button class="ml-10" type="primary" plain size="mini"
                    >详情</el-button
                  >
                </router-link>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <ul v-else class="list-style">
          <li v-for="item in notices">
            <router-link
              :to="'/dashboard/notices/detail/' + item.notice.id"
              v-permission="Auth.userNotice"
            >
              <div>
                <i
                  class="os-icon os-icon-eye"
                  style="color: #2f7ef5"
                  v-if="item.status == 1"
                ></i>

                {{ item.notice.title }}
              </div>
              <div class="font-12 text-black" style="margin: 5px 0">
                {{ item.notice.summary }}
              </div>
              <div class="flex-row-between text-black font-12">
                <span> 发布者：{{ showPublisher(item.notice) }} </span>
                <span class="text-gray">
                  {{ formatTime(item.created_at) }}
                </span>
              </div>
            </router-link>
          </li>
        </ul>
        <el-pagination
          class="mt-20"
          :page-size="filter.size"
          :current-page.sync="filter.page"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { userNoticeList, userNoticeCategoryList } from '@/service/getData'
import { clone } from '@/util'
import auth from '../../../util/auth'

import SearchFormer from '../search_former'
import { formatTime, isMobile } from '../../../util'

export default {
  components: {
    SearchFormer,
  },
  data() {
    return {
      loading: false,
      tabInex: '',
      isMobile,
      formatTime,
      secondCategory: '',
      filter: {
        notice_category_id: 0,
        second_category_id: 0,
        page: 1,
        size: 5,
      },
      total: 0,
      notices: [],
      categories: [],
    }
  },
  created() {
    if (this.$route.query.notice_category_id) {
      this.filter.notice_category_id = this.$route.query.notice_category_id
      this.tabInex = this.$route.query.notice_category_id

      this.filter.name = this.$route.query.name || ''
      this.filter.start_date = this.$route.query.start_date || ''
      this.filter.end_date = this.$route.query.end_date || ''
      this.filter.page = parseInt(this.$route.query.page) || 1
      this.filter.size = parseInt(this.$route.query.size) || 20
      if (this.$route.query.second_category_id) {
        this.filter.second_category_id = this.$route.query.second_category_id
      }
    }
    this.getCategories()
  },
  watch: {
    'filter.page': function () {
      this.getNotices()
    },
  },
  methods: {
    searchCallback(e) {
      this.filter.name = e.name
      this.filter.page = 1
      if (e.date && e.date.length > 0) {
        this.filter.start_date = e.date[0]
        this.filter.end_date = e.date[1]
      } else {
        this.filter.start_date = ''
        this.filter.end_date = ''
      }
      this.getNotices()
    },
    secondCategoryChange(e) {
      if (e) {
        this.filter.page = 1
        this.getNotices()
      }
    },
    handleTabClick(tab, event) {
      let currentTab = this.categories[tab.index]
      this.filter.notice_category_id = currentTab.id
      this.filter.second_category_id = currentTab.id
      this.filter.page = 1
      this.$refs.former.requestSearch('reset')
    },
    formartCategories(data) {
      let arr = []
      data.map((item) => {
        let father_id = item.father_id ? item.father_id : item.id
        let fathers = arr.filter((it) => it.id == father_id)

        if (fathers.length == 0) {
          if (item.father_id) {
            item.father.children = [{ id: item.id, name: item.name }]
            item.father.not_read_count = item.user_notices.length
            arr.push(item.father)
          } else {
            arr.push({
              id: item.id,
              name: item.name,
              children: [],
              not_read_count: item.user_notices.length,
            })
          }
        } else {
          if (item.father_id) {
            fathers[0].children.push({ id: item.id, name: item.name })
            fathers[0].not_read_count += item.user_notices.length
          }
        }
      })
      return arr
    },
    async getCategories() {
      let res = await userNoticeCategoryList()
      if (res.code == 0) {
        res.data.list.push({ id: 0, name: '其他', user_notices: [] })
        this.categories = this.formartCategories(res.data.list)
        if (!this.filter.notice_category_id && this.categories.length > 0) {
          let cate = this.categories[0]
          this.filter.notice_category_id = cate.id
          this.filter.second_category_id = cate.id
          this.tabInex = cate.id.toString()
        }
        this.getNotices()
      }
    },
    async getNotices() {
      this.$router.replace({
        query: this.filter,
      })

      let data = clone(this.filter)
      if (this.filter.second_category_id) {
        data.notice_category_id = this.filter.second_category_id
      }
      data.page -= 1
      this.loading = true
      let res = await userNoticeList(data)
      if (res.code == 0) {
        this.notices = res.data.list
        this.total = res.data.total
        this.loading = false
      }
    },
    showPublisher(notice) {
      if (notice.dealer_id == 0 && !auth.isPlatformUser()) {
        return '平台'
      } else {
        return notice.user.name
      }
    },
  },
}
</script>

<style >
.notice-tab.el-tabs--border-card {
  border-bottom: none;
}
.notice-tab.el-tabs--border-card,
.notice-tab.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background: #ffffff;
}
.notice-tab.el-tabs--border-card > .el-tabs__content {
  padding-top: 0;
  padding-bottom: 0;
}
</style>